
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisSarAircraftFixedwingFilled as ObiAisSarAircraftFixedwingFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-sar-aircraft-fixedwing-filled.js';
 
 
 

 
 export const ObiAisSarAircraftFixedwingFilled = createComponent({
   react: React,
   tagName: 'obi-ais-sar-aircraft-fixedwing-filled',
   elementClass: ObiAisSarAircraftFixedwingFilledElement,
   events: {
     
   }
  });
 
 